export const home_sp_auction_id = "1";
export const info_email_mailto= 'mailto:info@boundlessgiving.com';